"use client"

import { Button } from '@inflow/ui/components/button'
import { Card, } from '@inflow/ui/components/card'
import { AnimatePresence, motion } from 'motion/react'
import { useEffect, useState } from 'react'

export function GDPRBanner() {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('ga_consent')
    if (!consent) {
      setShowBanner(true)
    }
  }, [])

  const handleConsent = (status: 'granted' | 'denied') => {
    const consentSettings = {
      ad_storage: status,
      ad_user_data: status,
      ad_personalization: status,
      analytics_storage: status,
    };

    // 1. Save to LocalStorage immediately
    localStorage.setItem('ga_consent', JSON.stringify(consentSettings));

    // 2. Safely push to dataLayer (This is what gtag actually does)
    // We use window.dataLayer directly as a fallback to window.gtag
    if (typeof window !== 'undefined') {
      if (typeof (window as any).gtag === 'function') {
        (window as any).gtag('consent', 'update', consentSettings);
      } else {
        // If the library is slow or failed, we manually push to the queue
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(['consent', 'update', consentSettings]);
      }

      // Dispatch a custom event to notify GA that consent is updated
      // Use the array push method for maximum compatibility
      (window as any).dataLayer.push({
        event: 'consent_updated',
        consent_status: status
      });
    }

    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 0, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-9 left-1/2 z-[100] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2"
        >
          <Card className="grid gap-3 border-none bg-background/95 p-6 shadow-xl backdrop-blur">
            <h3 className="text-lg">Privacy Preferences</h3>
            <p className="text-muted-foreground text-xs">
              We use cookies to understand how you use our site and to improve your experience.
              This includes personalizing content and advertising.
            </p>
            <div className="mt-3 flex flex-col justify-end gap-3 sm:flex-row">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleConsent('denied')}
              >
                Essential only
              </Button>
              <Button
                size="sm"
                onClick={() => handleConsent('granted')}
              >
                Accept All
              </Button>
            </div>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
